import { Controller } from "@hotwired/stimulus"

// Marks the article section currently being read in the sticky Contents rail.
//
// Geometry rather than IntersectionObserver: the observer reports which
// headings are *on screen*, and for most of a long section that answer is
// "none of them" — so the rail would sit unmarked through exactly the stretch
// a reader most wants it. What the rail actually needs is "which heading did
// we last pass", which is a comparison against one line and always has an
// answer.
//
// The line sits below the sticky header, so a heading counts as passed once it
// has gone under the bar rather than when it leaves the viewport.
const PASSED_LINE = 140

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.headings = this.itemTargets
      .map((item) => document.getElementById(item.dataset.tocSection))
      .filter(Boolean)
    if (this.headings.length === 0) return

    this.onScroll = () => this.schedule()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  // Scroll fires far more often than the rail can meaningfully change; one
  // measurement per frame is the most that can ever be seen.
  schedule() {
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.update()
    })
  }

  update() {
    // Above the first heading the reader is in the intro, which belongs to the
    // first section as far as the rail is concerned — better than marking
    // nothing at all while the page sits at the top.
    let current = this.headings[0]
    for (const heading of this.headings) {
      if (heading.getBoundingClientRect().top > PASSED_LINE) break
      current = heading
    }

    if (current.id === this.activeId) return
    this.activeId = current.id
    this.itemTargets.forEach((item) => {
      item.classList.toggle("is-active", item.dataset.tocSection === this.activeId)
    })
  }
}
